import { basicInitialState } from '../_utils/basicInitialState';
import { TCompaniesState } from './companies';

export const companiesInitialState: TCompaniesState = {
  ...basicInitialState,
  companies: null,
  searchText: ''
};
